/* eslint-disable max-len */
import type { SvgProps } from '@main/core-ui/src/Icon/constants/enums';
import React from 'react';

export const HandShapes: React.FC<SvgProps> = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.99759 21.0038H3.99675C3.44432 21.0036 2.99654 20.5558 2.99634 20.0034V14.0009C2.99654 13.4485 3.44432 13.0007 3.99675 13.0005H5.99759C6.55002 13.0007 6.99781 13.4485 6.998 14.0009V20.0034C6.99781 20.5558 6.55002 21.0036 5.99759 21.0038V21.0038Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.0005 17.0021H14.9614C15.3943 17.0023 15.8156 16.8619 16.1619 16.6019L18.5789 14.7892C19.1823 14.3369 20.0264 14.3971 20.5597 14.9302V14.9302C20.8441 15.2143 21.0039 15.5997 21.0039 16.0017C21.0039 16.4036 20.8441 16.7891 20.5597 17.0731L18.4858 19.147C17.9271 19.7055 17.2156 20.0863 16.441 20.2414L13.5098 20.8277C12.9286 20.9439 12.3289 20.9296 11.754 20.7857L9.10292 20.1234C8.78598 20.0435 8.46037 20.0032 8.13352 20.0033H6.99805"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.0005 17.0022H14.4862C14.8882 17.0023 15.2737 16.8426 15.558 16.5583C15.8422 16.2741 16.0019 15.8885 16.0018 15.4865V15.1834C16.002 14.4882 15.5288 13.8822 14.8543 13.7138L12.5614 13.1405C12.1887 13.0475 11.806 13.0005 11.4219 13.0005V13.0005C10.4943 13.0002 9.58738 13.2749 8.8158 13.7898L6.99805 15.0013"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.271 6.7301C20.2477 7.70682 20.2477 9.29039 19.271 10.2671C18.2943 11.2438 16.7107 11.2438 15.734 10.2671C14.7573 9.29039 14.7573 7.70682 15.734 6.7301C16.203 6.26106 16.8392 5.99756 17.5025 5.99756C18.1658 5.99756 18.802 6.26106 19.271 6.7301"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.93153 6.04457C6.35302 5.46605 6.35302 4.52809 6.93153 3.94957L8.45165 2.42945C9.03017 1.85093 9.96813 1.85093 10.5467 2.42945L12.0668 3.94957C12.6453 4.52809 12.6453 5.46605 12.0668 6.04457L10.5467 7.56469C9.96813 8.14321 9.03017 8.14321 8.45165 7.56469L6.93153 6.04457Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
/* eslint-enable max-len */
